App.prototype.infiniteScrollProducts = function (cart) {
    if ($('.home-page').length) {
        let productsContainer;

        if(document.querySelector('.product-list-wrapper .products-holder')){
            productsContainer = document.querySelector('.product-list-wrapper .products-holder');
        }else if (document.querySelector('.product-list-wrapper')){
            productsContainer = document.querySelector('.product-list-wrapper');
        }else if (document.querySelector('.product-wrapper')){
            productsContainer = document.querySelector('.product-wrapper');
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.target.classList.contains('load-more-trigger')) {
                        let page = entry.target.dataset.page ? entry.target.dataset.page : 1;
                        loadMoreProducts(page);
                        entry.target.dataset.page = (parseInt(page) + 1).toString();
                    } else if (entry.target.classList.contains('infinite-page') && entry.target.classList.contains('unloaded')) {

                        console.info('intersecting ' + entry.target.dataset.page);
                        entry.target.classList.remove('unloaded');

                        loadMoreProducts(parseInt(entry.target.dataset.page), entry.target);
                    }
                } else if (entry.target.classList.contains('infinite-page') && !entry.target.classList.contains('unloaded')) {
                    entry.target.classList.add('unloaded');
                    entry.target.innerHTML = "";
                }
            });
        }, {
            rootMargin: '2000px',
            threshold: 0
        });

        const loadMoreTrigger = document.querySelector('.load-more-trigger');

        if (loadMoreTrigger){
            observer.observe(document.querySelector('.load-more-trigger'));
        }

        function loadMoreProducts(page, pageContainer = null) {
            const isHomePage = document.querySelector('.home-page') ? 'on' : 'off';

            fetch(`/api/products?page=${page}&isHomePage=${isHomePage}`)
                .then(response => response.json())
                .then(items => {

                    if (items.is_last_page) {
                        document.querySelector('.load-more-trigger').style.setProperty("display", "none", "important")
                    }else{
                        document.querySelector('.load-more-trigger').style.display = 'block';
                    }

                    let is_already_being_observed = true;

                    if (!pageContainer){
                        pageContainer = document.createElement('div');
                        pageContainer.classList.add('row', 'page-' + page, 'infinite-page');
                        if (productsContainer.dataset.infiniteRowClasses) {
                            pageContainer.classList.add(...productsContainer.dataset.infiniteRowClasses.split(' '));
                        }
                        pageContainer.dataset.page = page;
                        is_already_being_observed = false;
                    }

                    for (const item of items.data) {
                        pageContainer.innerHTML += item;
                    }

                    if (!is_already_being_observed){

                        productsContainer.appendChild(pageContainer);

                        const elPage = productsContainer.querySelector('.page-'+page);

                        elPage.style.height = elPage.clientHeight + 'px';

                        while (elPage.clientHeight === 0){
                            elPage.style.height = 'auto';
                            elPage.style.height = elPage.clientHeight + 'px';
                        }

                        observer.observe(productsContainer.querySelector('.page-'+page));
                    }

                })
                .catch(error => console.error('Error loading more products:', error));
        }
    }
}

App.prototype.infiniteScrollProducts();
